/*
 * Purpose: Zod schema for AI-generated AutoBlocks connectors
 * Last modified: 2026-06-25 | Agent
 * Completeness: 90
 */
import { z } from 'zod';

const capabilitySchema = z.object({
  id: z.string(),
  kind: z.enum(['trigger', 'tool', 'action']),
  label: z.string(),
  blockType: z.string(),
  blockSubtype: z.string(),
  description: z.string(),
});

export const aiConnectorSchema = z.object({
  id: z.string().regex(/^ab\.(custom\.)?[a-z0-9._-]+$/i),
  name: z.string(),
  category: z.string(),
  description: z.string(),
  auth: z.enum(['oauth2', 'api_key', 'webhook_inbound', 'secret', 'none']),
  capabilities: z.array(capabilitySchema).min(1),
  setupSteps: z.array(z.string()).min(1),
  runtime: z.enum(['client', 'edge', 'hybrid']).default('hybrid'),
  status: z.enum(['stable', 'beta', 'scaffold']).default('scaffold'),
  patternRef: z.string().optional(),
});

export const connectorFactoryResponseSchema = z.object({
  connectorIds: z.array(z.string()).default([]),
  newConnectors: z.array(aiConnectorSchema).default([]),
  rationale: z.string().optional(),
});

export type AiConnectorPayload = z.infer<typeof aiConnectorSchema>;
